module.exports = __webpack_public_path__ + "img/t@2x.2fe1d542.jpg";